const header = {

	elem: {
		body: document.querySelector('body'),
		header: document.querySelector('header'),
		menuItem: document.querySelectorAll('.nav-header-primary__item'),
		menuToggle: document.querySelector('.header__toggle-menu'),
		primaryNav: document.querySelectorAll('.header__primary .br-toggle'),
		searchForm: document.querySelector('#search-desktop'),
		searchToggle: document.querySelector('.header__toggle-search')
	},

	mql: {
		xlarge: window.matchMedia('(min-width: 1280px)')
	},

	adjustment: 0,
	scrollPositionLast: 0,	
	
	init() {
		if(header.elem.header !== null) {
			// Activate Accordions
			header.elem.primaryNav.forEach( function( element ) {
				element.toggle = Object.assign(new BRToggle(element, { accordion: true, navigation: 1024, open: false }));
			});
			
			$(document).on('click keydown', function(e) {		
				if(e.type === 'click') {
					if(!$(e.target).closest('#primary-navigation').length) {
						header.elem.primaryNav.forEach( function( element ) {
							element.toggle.closeAll();
						});
					}
				} else if (e.keyCode === 27) {
					header.elem.primaryNav.forEach( function( element ) {
						element.toggle.closeAll();
					});
				}
			});
			
			// Activate Search Slide-Out
			header.elem.searchForm.querySelector('input').setAttribute('tabindex', '-1');
			this.elem.searchToggle.addEventListener('click', function(e) {
				e.preventDefault();
				let pressed = event.target.getAttribute('aria-pressed');
				let label = event.target.getAttribute('aria-label');
				pressed = (pressed === 'true') ? 'false' : 'true';
				label = label.indexOf('Open') > -1 ? label.replace('Open', 'Close') : label.replace('Close', 'Open');
				event.target.setAttribute('aria-pressed', pressed);
				event.target.setAttribute('aria-label', label);
				event.target.querySelector('.show-for-sr').innerHTML = label;
				
				if( pressed === 'true') {
					header.elem.searchForm.querySelector('input').setAttribute('tabindex', '0');
					setTimeout(function() {
						header.elem.searchForm.querySelector('input').focus();
					}, 100);
				} else {
					header.elem.searchForm.querySelector('input').setAttribute('tabindex', '-1');
				}				
			});
			
			header.elem.menuToggle.addEventListener('click', function(e) {
				e.preventDefault();
				let pressed = event.target.getAttribute('aria-pressed');
				let label = event.target.getAttribute('aria-label');
				pressed = (pressed === 'true') ? 'false' : 'true';
				label = label.indexOf('Open') > -1 ? label.replace('Open', 'Close') : label.replace('Close', 'Open');
				event.target.setAttribute('aria-pressed', pressed);
				event.target.setAttribute('aria-label', label);
				event.target.querySelector('.show-for-sr').innerHTML = label;
				header.elem.body.classList.toggle('nav-open');	
			});

			header.adjustment = header.elem.header.offsetTop;
			
			$(document).on('scroll resize', this.onScroll.bind(this));		
			$(window).on('resize', this.reset.bind(this));
		}
	},

	onScroll() {
		let scrollPosition = window.pageYOffset || window.document.documentElement.scrollTop;	
		if (scrollPosition >= (150 + header.adjustment)) {
 			header.elem.header.classList.add('header--is-fixed');
		} else {
			header.elem.header.classList.remove('header--is-fixed');
		}	
		if ((scrollPosition >= (300 + header.adjustment)) && (scrollPosition < header.scrollPositionLast)	) {
			header.elem.header.classList.add('header--is-shown');
		} else {
			header.elem.header.classList.remove('header--is-shown');
		}
		header.scrollPositionLast = scrollPosition;
	},
	
	reset() {
		if(header.mql.xlarge.matches) {
			header.elem.body.classList.remove('nav-open');						
			header.elem.menuToggle.setAttribute('aria-pressed', 'false');
			header.elem.menuToggle.setAttribute('aria-label', 'Open primary navigation');
			header.elem.menuToggle.querySelector('.show-for-sr').innerHTML = 'Open primary navigation';
		}
	}
};

export { header };
